<template>
<div v-if="total > 1" :class="`ee-pager-bar text-${align}`">
  <span v-if="total > 5">共{{total}}页</span>
  <a :class="{disabled: value === 1}" :href="generateUrl(value - 1)">上一页</a>
  <span v-if="value > 3"><i class="text-icon icon-more"></i></span>
  <a v-for="i in list" :class="{'is-active': i === value}" :href="i === value ? 'javascript:;' : generateUrl(i)">{{i}}</a>
  <span v-if="(total - value) > 2"><i class="text-icon icon-more"></i></span>
  <a :class="{disabled: value === total}" :href="generateUrl(value + 1)">下一页</a>
  <template v-if="jump">
    <input type="text" @keydown.enter="handleJump" v-model="jumpTo" class="input input-small">
    <a class="btn btn-small" :href="goUrl">GO</a>
  </template>
</div>
</template>
<script>
  import {params2QueryString} from '../utils/qs'
  export default {
    compName: 'ee-pager-ssr',
    props: {
      align: { // ['left', 'right', 'center']
        type: String,
        default: 'center'
      },
      jump: Boolean,
      value: {
        type: Number,
        default: 1
      },
      total: {
        type: Number,
        default: 1
      }
    },
    data () {
      return {
        query: this.$route.query,
        curUrl: this.$route.path,
        jumpTo: this.total || 1
      }
    },
    methods: {
      generateUrl (pageIndex) {
        return params2QueryString(this.curUrl, {...this.query, pageIndex})
      },
      handleJump () {
        window.location.href = this.goUrl
      }
    },
    computed: {
      list () {
        const list = []
        for (let i = this.value - 2, max = this.value + 2; i <= max && i <= this.total; i++) {
          i > 0 && list.push(i)
        }
        return list
      },
      goUrl () {
        const to = Number(this.jumpTo)
        return this.generateUrl(isNaN(to) ? this.value : to)
      }
    }
  }
</script>
<style src="../style/pager.css"></style>




// WEBPACK FOOTER //
// src/packages/pager/PagerSSR.vue?1693312f